import { render, staticRenderFns } from "./AnimatorProgramDialog.vue?vue&type=template&id=580fde1f&scoped=true&"
import script from "./AnimatorProgramDialog.vue?vue&type=script&lang=js&"
export * from "./AnimatorProgramDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580fde1f",
  null
  
)

export default component.exports